exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".explosion-btn[data-v-898c2222]{position:fixed;bottom:5px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);width:362px;height:40px;line-height:40px;text-align:center;background:-webkit-gradient(linear,left top,left bottom,from(#113444),to(#097fa4));background:linear-gradient(#113444,#097fa4);border-radius:32px;color:#fff;font-size:16px;cursor:pointer;letter-spacing:1px}", ""]);

// exports
